import { observer } from 'mobx-react-lite'
import type { TaxJobDetailsViewModel } from '@/features/jobs/details/tax-type/TaxJobDetailsViewModel'
import {
  FinalReturnDownloadActionCard,
  FinalReturnDownloadScrolledAction,
  FinalReturnDownloadSection,
} from '@/features/jobs/details/tax-type/components/FinalReturn/index'

interface FinalReturnDownloadSectionContainerProps {
  vm: TaxJobDetailsViewModel
}

/**
 * Container for the final return download section.
 */
export const FinalReturnDownloadSectionContainer = observer(
  function FinalReturnDownloadSectionContainer({
    vm,
  }: FinalReturnDownloadSectionContainerProps) {
    const docVm = vm.progressionVm.finalReturnVm.finalReturnDocumentVm
    if (!docVm) {
      return null
    }

    return (
      <FinalReturnDownloadSection
        uploadedAt={docVm?.doc.dateCreated}
        onDownloadPress={() => docVm.download()}
      />
    )
  },
)

interface FinalReturnDownloadActionCardContainerProps {
  vm: TaxJobDetailsViewModel
}

/**
 * Final Return Download Action Card Container
 */
export const FinalReturnDownloadActionCardContainer = observer(
  function FinalReturnDownloadActionCardContainer({
    vm,
  }: FinalReturnDownloadActionCardContainerProps) {
    const docVm = vm.progressionVm.finalReturnVm.finalReturnDocumentVm
    if (!docVm) {
      return null
    }

    return <FinalReturnDownloadActionCard onDownloadPress={docVm.download} />
  },
)

interface FinalReturnDownloadScrolledActionContainerProps {
  vm: TaxJobDetailsViewModel
}

/**
 * Final Return Download Scrolled Action Container
 */
export const FinalReturnDownloadScrolledActionContainer = observer(
  function FinalReturnDownloadScrolledActionContainer({
    vm,
  }: FinalReturnDownloadScrolledActionContainerProps) {
    const docVm = vm.progressionVm.finalReturnVm.finalReturnDocumentVm
    if (!docVm) {
      return null
    }

    return (
      <FinalReturnDownloadScrolledAction onDownloadPress={docVm.download} />
    )
  },
)
